// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.opportunities-container {
  max-width: 1000px;
  margin: 2rem auto;
  padding: 2rem;
}

.filter-section {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.opportunities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.opportunity-card {
  background: #f9faf9;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transition: transform 0.2s;
}

.opportunity-card:hover {
  transform: translateY(-5px);
}

.opportunity-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.opportunity-category {
  font-style: italic;
  color: #555;
  margin-bottom: 0.5rem;
}

.opportunity-description {
  margin-bottom: 0.5rem;
}

.opportunity-location,
.opportunity-member {
  font-size: 0.9rem;
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Opportunities.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".opportunities-container {\n  max-width: 1000px;\n  margin: 2rem auto;\n  padding: 2rem;\n}\n\n.filter-section {\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.opportunities-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.opportunity-card {\n  background: #f9faf9;\n  padding: 1rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  transition: transform 0.2s;\n}\n\n.opportunity-card:hover {\n  transform: translateY(-5px);\n}\n\n.opportunity-title {\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n}\n\n.opportunity-category {\n  font-style: italic;\n  color: #555;\n  margin-bottom: 0.5rem;\n}\n\n.opportunity-description {\n  margin-bottom: 0.5rem;\n}\n\n.opportunity-location,\n.opportunity-member {\n  font-size: 0.9rem;\n  color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
